---
en:
  rows:
    connection: connection
    connections: connections
  suppliers:
    add_supplier: Add supplier
    categories:
      advisor_commercial: Advisor commercial
      advisor_legal: Advisor legal
      advisor_mna: Advisor M&A
      advisor_technical: Advisor technical
      association: Association
      consultant: Consultant
      electricity_company: Electricity company
      entrepreneur: Entrepreneur
      equipment_supplier: Equipment supplier
      finance: Finance
      grid_owner: Grid owner
      insurance: Insurance
      investor: Investor
      journalist: Journalist
      operation_and_maintenance: Operation & maintenance
      other: Other
      power_trader: Power trader
      risk_management: Risk management
      student: Student
      telecommunication: Telecommunication
    category: Category
    roles:
      control_system: Control system
      generator: Generator
      turbine: Turbine
    supplier: Supplier
    supplier_created: Supplier created
    supplier_role: Supplier role
    supplier_updated: Supplier updated
    suppliers: Suppliers
    url_facebook: Facebook
    url_homepage: Website
    url_instagram: Instagram
    url_linked_in: LinkedIn
